import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { EPrescribeComponentModule } from "components/eprescribe/eprescribe.component.module";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { PatientEPrescribePage } from "./patient-eprescribe";

@NgModule({
  entryComponents: [],
  declarations: [PatientEPrescribePage],
  imports: [
    IonicPageModule.forChild(PatientEPrescribePage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
    TruncateModule,
    EPrescribeComponentModule,
  ],
  exports: [PatientEPrescribePage],
})
export class PatientEPrescribePageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-eprescribe/patient-eprescribe.module.ts